import { useEffect, useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import { useGetTaxcategoryQuery, useGetAllcompanyQuery } from '../../../../store/api/Salestaxes';
import Table from './Table';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const Tab1 = ({ pageState, setPageState, handleChange }) => {
  const [taxoptions, setTaxoptions] = useState([])
  const [companyoptions, setCompanyoptions] = useState([])
  const { data: taxCat, isError, isLoading } = useGetTaxcategoryQuery()
  const { data: companydata } = useGetAllcompanyQuery()

  useEffect(() => {
    if (taxCat?.data?.length) {
      setTaxoptions(taxCat.data)
    }
  }, [taxCat])
  useEffect(() => {
    if (companydata?.data?.length) {
      setCompanyoptions(companydata.data)
    }
  }, [companydata])

  return (
    <div>
      <div className="px-4 py-4" style={{ background: 'white' }}>

        <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>




              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>

              </div>



              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>

                  <Input
                    type='text'
                    id="QualityProcedure"
                    label="Quality Procedure"
                    style={{
                      height: "30px"
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>

                  <Input
                    type='text'
                    id="process_owner"
                    label="Process Owner"
                    style={{
                      height: "30px"
                    }}
                  />
                </div>
              
              </div>



          
            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>


              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Parent</p>
                </div>

              </div>



              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>

                  <Input
                    type='text'
                    id="parent_procedure"
                    label="Parent Procedure"
                    style={{
                      height: "30px"
                    }}
                  />
                </div>
                <div style={{ flex: 1 }}>
                  <label style={{ height: '5.4px' }}></label>
                  <Checkbox
                    id="is_group"
                    label="Is Group"
                  />
                </div>
              
              </div>
             




            </div>
          </div>

        </div>


        <div className="mb-3" style={{ display: 'flex', gap: '20px', border: '1px solid #DBDBDB', borderRadius: '5px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='' style={{ fontSize: '16px', fontWeight: '600' }}>Processes</p>
                </div>
              </div>

              <Table taxes={{ value: pageState.taxes, setValue: (v) => setPageState({ ...pageState, taxes: v }) }} compname={pageState.company} />



            </div>
          </div>

        </div>




      </div>
    </div>
  )
}

export default Tab1